import { USER_FORM } from './form-portaluser-type'; 
import { displayPartnerCustomerList } from '../../widgets/partner-customer-widget';

/**
 * Function to remove a linked item to a portal user.
 * 
 * @param {string} accessElement the elements class name
 * @param {any} id the items unique id
 */
export const removePartnerCustomerAccess = (accessElement: string, id: any) => {
  let getAccessList = document.querySelector(accessElement) as HTMLElement;
  let customerListContainer = document.querySelector('.aafp_list-result-container') as HTMLElement;
  let removeEle = document.querySelector('.ele_access_' + id);
  let elementData: object[] =  [];

  elementData.push({
    id: removeEle!.getAttribute('data-id'),
    name: removeEle!.getAttribute('data-name')
  });

  if(!getAccessList) return;
  getAccessList.addEventListener('click', () => {
    //@ts-ignore
    displayPartnerCustomerList(elementData, customerListContainer);    
    removeEle?.remove();
  });
}

/**
 * Function that assigns access levels per role
 * 
 * @param {string} userRole
 * @returns object
 */
export const getAccessPrevilages = (userRole: string) => {
  var access;
  function isCardGroup() {
    return access = { 'accessLevel': 'G', 'accessType': 'R' };
  }

  function isCustomer() {
    let type = userRole.includes('admin') ? 'E' : 'R';
    return access = { 'accessLevel': 'C', 'accessType': type };
  }

  function isSite() {
    return access = { 'accessLevel': 'B', 'accessType': 'R' };
  }

  function isPartner() {
    let type = userRole.includes('admin') ? 'E' : 'R';
    return access = { 'accessLevel': 'P', 'accessType': type };
  }

  function isAAG() {
    let type = userRole.includes('admin') ? 'E' : 'R';
    return access = { 'accessLevel': 'A', 'accessType': type };
  }

  var roles = {
    'card_group_reporting': isCardGroup,
    'customer_reporting': isCustomer,
    'customer_admin': isCustomer,
    'site_reporting': isSite,
    'site_admin': isSite,
    'partner_reporting': isPartner,
    'partner_admin': isPartner,
    'aag_reporting': isAAG,
    'aag_admin': isAAG
  }
  // @ts-ignore
  return roles[userRole]();
}

/**
 * Formats the access list
 */
export const getAndFormatAccessList = () => {
  let accessList: string = '';
  
  const adminRoles = [
    "aag_reporting",
    "aag_admin",
    'pers'
  ];

  let customerList = document.querySelectorAll<HTMLElement>('[data-linked]');

  if(customerList) {
    customerList.forEach(e => {
      let customerId = e.getAttribute('data-linked');
      accessList += customerId + ','; 
    });
  }      

  if(adminRoles.includes(USER_FORM.userRole.getAttribute('data-value')!)) {
    accessList = '0,';
  }

  if(!accessList) {
    USER_FORM.userErrorMsg.innerHTML = `One customer/partner must be associated with this user.`;
    return '';
  }

  USER_FORM.userErrorMsg.innerHTML = ``;
  return accessList.slice(0, -1);
}